import { render } from "./InvoiceDetail.vue?vue&type=template&id=2c55e9f8&scoped=true&ts=true"
import script from "./InvoiceDetail.vue?vue&type=script&lang=ts"
export * from "./InvoiceDetail.vue?vue&type=script&lang=ts"

import "./InvoiceDetail.vue?vue&type=style&index=0&id=2c55e9f8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c55e9f8"]])

export default __exports__